export default function LINEMENU (){
      
        if(document.getElementById("NavHomeParen")){
            document.getElementById("NavHomeParen").id="NavHomeParent"
        }else{
            document.getElementById("NavHomeParent").id="NavHomeParen"
        }
        
}